import {times, sample, shuffle, random, filter} from 'lodash-es';
import moment from 'moment';

// List of Historical Names (Lname, Fname) for use in the dummy data.
const historicalNames = [
  'Austen, Jane',
  'Blake, William',
  'Chisholm, Shirley',
  'DiMaggio, Joe',
  'Dresselhaus, Mildred',
  'Earhart, Amelia',
  'Hamilton, Alexander',
  'Height, Dorothy',
  'Hopper, Grace',
  'Jackson, Bo',
  'Turing, Alan',
];

const getFakeAnswers = () => {
  // Generate a set of 4 answers that are randomly correct or incorrect.
  // (Favoring correct answers)
  return times(4, () => {
    return {is_correct: sample([true, true, false])};
  });
};

export function getWorkDetailsDummyData() {
  const names = shuffle(historicalNames);
  // Let's fake 7 pieces of student data for the WorkDetails component!
  return times(7, (index) => {
    // Annotation count
    const annotationCount = random(0, 6);

    // Article level
    const articleLevel = sample([4, 6]);

    // Last activity
    const completed = moment().subtract(random(0, 4), 'd').format();

    // Student name
    const name = names[index];

    // Quiz object
    const quizAnswers = getFakeAnswers();
    const correctAnswers = filter(quizAnswers, 'is_correct') || [];
    const possibleScores = [0, 25, 50, 75, 100];
    const quiz = {
      // We also need a set of answers for the quiz.
      answers: quizAnswers,
      // "Get" the score by choosing one of the possible choices (zero-based)
      score: possibleScores[correctAnswers.length],
    };

    // Fake the reading time (somewhere between 3 and 45 minutes)
    const readingTime = random(180, 2700);

    // Fake Write Response & Review
    const now = new Date();
    const writeResponse = {
      id: sample(null, 1),
      review: {
        date_shared: sample(null, now),
        score: sample(1, 2, 3)
      },
      student: {user: 'username'}
    };

    // Return our new dummy student
    return {
      annotationCount,
      articleLevel,
      completed,
      name,
      quiz,
      readingTime,
      writeResponse,
    };
  });
}

export function getStudentTabDummyData() {
  const names = shuffle(historicalNames);
  // Let's fake 9 pieces of student data for the Student Tab!
  return times(9, (index) => {
    const level = sample([2, 4]);
    return {
      achievement_bucket: `level_${level}`,
      annotationsPerHeader: 1.5,
      'count:annotations': 3,
      'count:header_views': 6,
      'count:quizzes': 6,
      'count:write_response_score': 2,
      'avg:quiz_score': 25,
      'avg:write_response_score': 1.5,
      currentReadingLevel: 3.97,
      currentReadingLevelConfidence: 4.15,
      percentile: level * 25,
      student_id: index,
      name: names[index],
    };
  });
}
